import WebGalleriesAlbumView from './WebGalleriesAlbumView';

export default WebGalleriesAlbumView;
